export function siftFilterGrouping(baseArr, regexString) {
  if(regexString === '') {
    return baseArr
  }

  const specialChars = /[.*+?^${}()|[\]\\]/g;
  let search = new RegExp(`.*${regexString.replace(specialChars, '').toLowerCase()}.*`)

  let newFilterData = JSON.parse(JSON.stringify(baseArr))
  for(let group of newFilterData) {
    group.data = group.data.filter((a) => {
      let testString = a.label.replace(specialChars, '').toLowerCase()
      return testString.match(search)
    })
  }
  
  return newFilterData
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/siftFilterGrouping.js